<template>
  <div class="row">
    <!-- <div id="mapBoxMapFullView" class="row col-12 mapStyle2">

    </div> -->
    <div class="col-5">
      <div id="mapBoxMapFullView" class="row col-12 mapStyle2">

      </div>
    </div>
    <div class="col-2" :hidden="isLoggedIn">
      <div class="card">

        <!-- <div class="card-header">
          <label>
            <h2>
              Report Generation
            </h2>
          </label>
        </div> -->

        <form class="card-body">
          <label for=""><h4>User Name</h4></label>
          <input type="text" class="form-control" v-model="userName">
          <br>
          <label for=""><h4>Password</h4></label>
          <input type="password" class="form-control" v-model="password">
          <br>
          <div class="row">
            <div class="col-7">
              <label for="">ObjectID Start</label>
            </div>
            <b-form-input type="number" name="" v-model="startingObjectId" class="col-4"></b-form-input>
          </div>
          <br>
          <div class="row">
            <div class="col-7">
              <label for="">No. of Latest Features</label>
            </div>
            <b-form-select class="col-4" name="" v-model="numberOfFeatures">
              <option value="0" default>All</option>
              <option value="5">5</option>
              <option value="20">20</option>
              <option value="100">100</option>
            </b-form-select>
          </div>
          <br>
          <button class="btn btn-primary" v-on:click.prevent="initializeData">Start</button>
        </form>
      </div>
    </div>
    <div class="col-2" :hidden="!isLoggedIn">
      <div class="card">
        <div class="card-body">
          <div class="row" v-if="areResourcesLoaded&&mapBlobsLoaded">

            <h5>
              Data Fetched successfully, please generate the report by clicking the Generate Report Button
            </h5>
            <div class="col-6">

              <button class="btn btn-outline-primary" v-on:click="generateReport">Generate Report</button>
            </div>
            <div class="col-6">

              <button class="btn btn-outline-danger" v-on:click.prevent="accountLogout">Logout</button>
            </div>
          </div>
          <template v-else>
            <h4>
              <i class="fas fa-spinner fa-spin"></i> Fetching data from the portal, please wait
            </h4>
          </template>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div id="mapBoxMap" :hidden="true" class="row col-10 mapStyle">

      </div>

    </div>
    <div class="col-2">
      <b-alert variant="danger" v-model="showErrorMessage">
        {{errorMessage}}
      </b-alert>
      <b-alert variant="success" v-model="showSuccessMessage">
        {{successMessage}}
      </b-alert>
    </div>
  </div>
</template>

<script>
import {Document, Packer, Paragraph, Table, BorderStyle, Media, PageOrientation, WidthType, TableRowProperties, VerticalAlign} from "docx";
import axios from "axios";
import Qs from 'qs'
import {redirectURL, mapBoxToken, documentReportConfig, mapUrl} from "../../config.js"
import loadImage from "blueimp-load-image"
import JSZip2 from 'jszip2'

import mapboxgl from 'mapbox-gl'
require('mapbox.js')

import 'mapbox-gl/src/css/mapbox-gl.css'
export default {
  name: 'Map',
  props: {
    msg: String
  },
  data() {
    return {
      dataLayer: {},
      doc: {},
      table: {},
      isLoggedIn: false,
      areResourcesLoaded: false,
      mapBlobsLoading: false,
      mapBlobsLoaded: false,
      dataFeatures: [],
      imgCount: 0,
      imgLoadedCount: 0,
      generateTokenURL: mapUrl.generateToken,
      dataLayerBaseURL: mapUrl.dataLayerBase,
      constraintLayerBaseURL: mapUrl.constraintLayerBase,
      constraintTurbinesBaseURL: mapUrl.constraintTurbines,
      constraintHardstandsBaseURL: mapUrl.constraintHardstands,
      constraintLayers: [],
      accessToken: "",
      imageBlobs: [],
      imageBlobsOriginal: [],
      userName: "",
      password: "",
      errorMessage: "",
      showErrorMessage: false,
      successMessage: "",
      showSuccessMessage: false,
      mapToken: mapBoxToken,
      mapBoxMap: {},
      map: {},
      mapBlobs: [],
      styles: [
        {id: 0, color:"#999999", name: "Layout"},
        {id: 1, color:"#A80000", name: "Line"},
        {id: 2, color:"#8A1200", name: "Weed pts"},
        {id: 3, color:"#f2b13a", name: "Homewood rd trees"},
        {id: 4, color:"#543701", name: "Scattered trees"},
        {id: 5, color:"#197502", name: "Mature trees"},
        {id: 6, color:"#ea83cd", name: "Weed pts"},
        {id: 7, color:"#888888", name: "Ownership", style:"line"},
        {id: 8, color:"#00FF00", name: "Native veg loss", style:"fill", opacity:0.9},
        {id: 9, color:"#350FB8", name: "Proposed offset", style:"fill", opacity:0.4},//outline - 00A884
        {id: 10, color:"#0FB862", name: "Native vegetation", style:"fill", opacity:0.4},
        {id: 11, color:"#E883E2", name: "Blackberry patches (weed)", style:"fill"},
        {id: 12, color:"#CC0000", name: "Crown Land", style:"fill"}
      ],
      legendBlobs: [],
      mapFullViewBlob: {},
      mapFullView: {},
      dataFeaturesFull: {},
      objLegendBlob: {},
      reportTitle: documentReportConfig.docTitle,
      tableHeaderLabel: documentReportConfig.docTableHeader,
      tableHeader: ["objectId", "locationDesc", "note", "image", "mapLocation"],
      constraintTurbines: {},
      numberOfFeatures: 0,
      startingObjectId: 0
    }
  },
  methods: {
    sleep: function(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    generateReport: function(){
      const current = this
      var title = current.reportTitle + " Data"
      current.doc = new Document(undefined, {
        creator: "",
        title: title,
        description: "",
        orientation: PageOrientation.LANDSCAPE
      })
      current.doc.Styles.createParagraphStyle('Heading1', 'Heading 1')
          .basedOn("Normal")
          // .next("Normal")
          .color("E66200")
          .font("Arial Bold")
          .size(32)
          .bold()
          .spacing({ after: 120 });
      current.doc.Styles.createParagraphStyle('TableHeader', 'Table Header')
          .basedOn("Normal")
          .next("Normal")
          .size(20)
          .color("FFFFFF")
          .font("Arial (Body)")
          .center()
          .bold()
          .indent({ left: 50, right: 50 })
          .spacing({ before: 50, after: 50 });
      current.doc.Styles.createParagraphStyle('TableColumn1', 'Table Column 1')
          .basedOn("Normal")
          .next("Normal")
          .size(20)
          .color("55575A")
          .font("Arial (Body)")
          .bold()
          .indent({ left: 50 })
          .spacing({ before: 50, after: 50 });
      current.doc.Styles.createParagraphStyle('TableColumn2', 'Table Column 2')
          .basedOn("Normal")
          .next("Normal")
          .size(20)
          .color("55575A")
          .font("Arial (Body)")
          .indent({ left: 50 })
          .spacing({ before: 50, after: 50 });
      current.doc.Styles.createParagraphStyle('TableColumn3', 'Table Column 3')
          .basedOn("Normal")
          .next("Normal")
          .size(20)
          .color("55575A")
          .font("Arial (Body)")
          .spacing({ before: 50, after: 50});

      current.doc.createParagraph(current.reportTitle + ' Full Project').heading1();
      if (typeof current.mapFullViewBlob != "undefined") {
        let mapImage = Media.addImage(current.doc, current.mapFullViewBlob, 529, 550)
        current.doc.addParagraph(mapImage.paragraph)
      }
      current.doc.createParagraph(current.reportTitle + ' Data').heading1();
      // Table Headers
      var headers = {};
      current.tableHeaderLabel.map(function(obj,index){
        headers[current.tableHeader[index]] = obj;
      });

      current.table = current.doc.createTable({
          rows: current.dataFeatures.length+1,
          columns: Object.keys(headers).length,
      });
      console.log(current.table);
      console.log((current.dataFeatures.length+1)+", "+ Object.keys(headers).length);
      current.table.properties.setWidth('100%', WidthType.PERCENTAGE)
      Object.keys(headers).forEach((headerItem, headerIndex)=>{
        // To set the table header borders
        current.table.getCell(0, headerIndex).Borders.addTopBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                            .addBottomBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                            .addStartBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                            .addEndBorder(BorderStyle.SINGLE, 3, "#B3B3B3");
        // To set the table header text
        let headerColumn = new Paragraph(headers[headerItem]).style("TableHeader")
        current.table.getCell(0, headerIndex).addParagraph(headerColumn).setShading({fill:"E66200", color:"FFFFFF"});
      })
      // console.log(current.table.getRow(0));
      current.table.getRow(0).setCantSplit();
      current.table.getRow(0).setTableHeader();
      var zip = new JSZip2();
      // var imagesFolder = zip.folder("Images");
      // Table Contents
      current.dataFeatures.forEach((item,index)=>{
        Object.keys(headers).forEach((headerItem, headerIndex)=>{
          if(headerItem == "objectId") {
            current.table.getCell(index+1, headerIndex).addParagraph(new Paragraph(item[headerItem]).style("TableColumn1")).properties.setWidth('10%', WidthType.PERCENTAGE);
          }
          else if(headerItem == "image"){
            var imagesObjFolder = zip.folder(item.objectId);
            item[headerItem+"Ids"].forEach((imageId, imgIndex)=>{
              if (imgIndex < 2) {
                var image = Media.addImage(current.doc, current.imageBlobs[imageId], 178, 240)
                if (typeof image != "undefined") {
                  current.table.getCell(index+1, headerIndex).addParagraph(image.paragraph.style("TableColumn1")).properties.setWidth('20%', WidthType.PERCENTAGE);
                  imagesObjFolder.file(item.objectId+"_"+imgIndex+".png",current.imageBlobsOriginal[imageId], {base64: true})
                }
              }
            })
          }
          else if (headerItem == "mapLocation") {
            var mapImage = Media.addImage(current.doc, current.mapBlobs[item.objectId], 280, 240)
            if (typeof mapImage != "undefined") {
              current.table.getCell(index+1, headerIndex).addParagraph(mapImage.paragraph.style("TableColumn1")).properties.setWidth('20%', WidthType.PERCENTAGE);
            }
          }
          else{
            current.table.getCell(index+1, headerIndex).addParagraph(new Paragraph(item[headerItem]).style("TableColumn2")).properties.setWidth('30%', WidthType.PERCENTAGE);
            if (headerItem=="locationDesc") {
              var locItemX = "Longitude: " + item.x.toFixed(4) + "\xB0"
              var locItemY = "Latitude: " + item.y.toFixed(4) + "\xB0"
              current.table.getCell(index+1, headerIndex).addParagraph(new Paragraph(locItemX).style("TableColumn2")).properties.setWidth('20%', WidthType.PERCENTAGE);
              current.table.getCell(index+1, headerIndex).addParagraph(new Paragraph(locItemY).style("TableColumn2")).properties.setWidth('20%', WidthType.PERCENTAGE);
            }
          }
          // To set the table contents borders
          if(headerIndex == 0 || headerIndex == (Object.keys(headers).length - 1)) {
            current.table.getCell(index+1, headerIndex).Borders.addTopBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                                .addBottomBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                                .addStartBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                .addEndBorder(BorderStyle.SINGLE, 3, "#FFFFFF");
          }
          else {
            current.table.getCell(index+1, headerIndex).Borders.addTopBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                                .addBottomBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                                .addStartBorder(BorderStyle.SINGLE, 3, "#B3B3B3")
                                .addEndBorder(BorderStyle.SINGLE, 3, "#B3B3B3");
          }
        })
      })
      // current.doc.addTable(current.table)
      // current.doc.addParagraph(new Paragraph("Map Location Legend").style("TableColumn2").keepNext())
      current.doc.addParagraph(new Paragraph().style("TableColumn2").keepNext())
      current.doc.addParagraph(new Paragraph().style("TableColumn2").keepNext())
      current.doc.addParagraph(new Paragraph("Map Legend").style("TableColumn1").keepNext())
      var styles = current.styles.filter(styleObj=> styleObj.id != 4 && styleObj.id!=10)
      var legendTable = current.doc.createTable({
        rows: styles.length+1,
        columns: 2
      })
      legendTable.properties.setWidth('15%', WidthType.PERCENTAGE)

      styles.forEach((styleItem,styleIndex)=>{
        let legendBlob = current.legendBlobs[styleItem.id]
        legendTable.getCell(styleIndex, 0).Borders.addTopBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                  .addBottomBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                  .addStartBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                  .addEndBorder(BorderStyle.SINGLE, 3, "#FFFFFF");
        legendTable.getCell(styleIndex, 1).Borders.addTopBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                  .addBottomBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                  .addStartBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                  .addEndBorder(BorderStyle.SINGLE, 3, "#FFFFFF");
        legendTable.getCell(styleIndex, 1).addParagraph(new Paragraph(styleItem.name).style("TableColumn3")).properties.setVerticalAlign(VerticalAlign.CENTER)
        if (typeof legendBlob != "undefined") {

          let image = Media.addImage(current.doc, legendBlob, 49, 30)
          legendTable.getCell(styleIndex, 0).addParagraph(image.paragraph);
        }
      })

      legendTable.getCell(styles.length, 1).addParagraph(new Paragraph("Collected Data").style("TableColumn3")).properties.setVerticalAlign(VerticalAlign.CENTER)
      if (typeof current.objLegendBlob != "undefined") {
        let image = Media.addImage(current.doc, current.objLegendBlob, 49, 30)
        legendTable.getCell(styles.length, 0).addParagraph(image.paragraph);
      }
      legendTable.getCell(styles.length, 0).Borders.addTopBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                .addBottomBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                .addStartBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                .addEndBorder(BorderStyle.SINGLE, 3, "#FFFFFF");
      legendTable.getCell(styles.length, 1).Borders.addTopBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                .addBottomBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                .addStartBorder(BorderStyle.SINGLE, 3, "#FFFFFF")
                                                .addEndBorder(BorderStyle.SINGLE, 3, "#FFFFFF");

      const packer = new Packer();
      packer.toBlob(current.doc).then(blob => {

        zip.generateAsync({type:"blob"}).then(function(content) {
          var zipFinal = new JSZip2();
          zipFinal.file("Images.zip", content)
          zipFinal.file(title + " report.docx", blob);

          zipFinal.generateAsync({type:"blob"}).then(function(finalContent) {
            var url = window.URL.createObjectURL(finalContent)
            var link = document.createElement('a');
            document.body.appendChild(link)
            link.style = "display: none"
            link.href = url;
            link.download = title + ".zip";
            link.click();
            window.URL.revokeObjectURL(url);
          })
        });
      })
      current.successMessage = "Report generation complete! You can now download your report."
      current.showSuccessMessage = true
      setTimeout(function() {
        current.showSuccessMessage = false
        current.successMessage = ""
        // current.accountLogout();
        window.location.reload()
      },2500);
    },
    handleEvent: function(event) {
      console.log(event);
    },
    initializeData: function() {
      const current = this
      if (current.userName && current.password) {
        current.accountLogin(current).then(data=>{
          current.accessToken = data.token // token needs to be a request body item
          current.setDataFeatures(current).then(features=>{
            features.forEach(feature=>{
              current.getImageConfigs(current, feature.objectId).then(result=>{
                feature.imageIds.forEach(id=>{
                  current.getImageBlobs(current, id)
                })
              })
            })
          }).catch(itemAccessError=>{
            console.log(itemAccessError);
            current.errorMessage = "User does not have proper access to the data contents. Please contact the data owner for access."
            current.showErrorMessage = true
            setTimeout(function() {
              current.showErrorMessage = false
              current.errorMessage = ""
            },2500);
            // alert("User does not have proper access to the data contents. Please contact the data owner for access.")
            current.accountLogout;
          })
        }).catch(accountLoginError=>{
          current.errorMessage = accountLoginError + " Please enter the correct username and password to continue"
          current.showErrorMessage = true
          setTimeout(function() {
            current.showErrorMessage = false
            current.errorMessage = ""
          },2500);
        })
      }
      else {
        alert("Please enter both username and password to access Portal data")
      }
    },
    accountLogin: function(current) {
      return new Promise(function(resolve, reject) {
        var params = {
          username: current.userName,
          password: current.password,
          client: "referer",
          referer: redirectURL, // should be replaced by state-specific url (dev vs live production)
          f: "json"
        }
        var tokenConfig = {
          url: current.generateTokenURL,
          method: "POST",
          data: Qs.stringify(params),
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          withCredentials: true
        }
        // resolve(tokenConfig.params)
        axios(tokenConfig).then(result=>{
          console.log(result);
          if (typeof result.data.error == "undefined") {
            current.isLoggedIn = true
            resolve(result.data)

          }
          else {
            reject(result.data.error.message)
          }
        })
      });
    },
    setDataFeatures: function(current) {
      return new Promise(function(resolve, reject) {
        current.imgCount = 0;
        current.imgLoadedCount = 0;
        var data = {
          token: current.accessToken,
          f: "json",
          where: "objectid is not null and objectid <> 1",
          outFields: "*",
          outSR: 4326,
          orderByFields: "objectid ASC"
        }
        if (current.numberOfFeatures > 0) {
          data.resultRecordCount = current.numberOfFeatures
          console.log(data);
        }
        if (current.startingObjectId > 0) {
          data.where += " and objectid >= " + current.startingObjectId
        }
        var dataLayerConfig = {
          url: current.dataLayerBaseURL+"query",
          method: "POST",
          data: Qs.stringify(data),
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          }
        }
        current.getConstraintLayers();
        axios(dataLayerConfig).then(result=>{
          if (typeof result.data.error == "undefined") {
            current.dataFeatures = []
            current.dataFeaturesFull = result.data
            result.data.features.forEach(feature=>{
              let rowData = {
                objectId: feature.attributes.objectid,
                locationDesc: (feature.attributes.locationdesc?feature.attributes.locationdesc:""),
                note: feature.attributes.note,
                imageIds: [],
                x: feature.geometry.x,
                y: feature.geometry.y
              }
              current.dataFeatures.push(rowData)
            })
            resolve(current.dataFeatures)
          }
          else {
            reject(result.data.error.message)
          }
        })

      })
    },
    getImageConfigs: function(current, objectId){
      return new Promise(function(resolve, reject) {
        let imageConfig = {
          url: current.dataLayerBaseURL+objectId+"/attachments",
          method: "POST",
          data: Qs.stringify({
            token: current.accessToken,
            f: "json",

          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          }
        }
        var imageBlob = []
        axios(imageConfig).then(result=>{
          result.data.attachmentInfos.filter(obj=>obj.contentType.includes("image")).forEach(imageDetail=>{
            current.dataFeatures.filter(obj=>obj.objectId == objectId)[0].imageIds.push(imageDetail.id)
            current.imgCount += 1;
          })
          resolve(true)
        })
        // console.log(imageBlob);
      });

    },
    getImageBlobs: function(current, imageId) {
      return new Promise(function(resolve, reject) {
        let objectId = current.dataFeatures.filter(obj=>obj.imageIds.includes(imageId))[0].objectId
        let imageAttachmentConfig = {
          url: current.dataLayerBaseURL+objectId+"/attachments/"+imageId,
          method: "POST",
          data: Qs.stringify({
            token: current.accessToken
          }),
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          responseType: "blob"
        }
        axios(imageAttachmentConfig).then(result=>{
          let image =  new Blob(
            [result.data],
            {type: result.headers['content-type']}
          );
          current.setRotateImage(current, image, imageId)
          // current.imageBlobs[imageId] = image
          current.imgLoadedCount += 1;
          resolve(true)
        })
      });
    },
    accountLogout: function() {
      const current = this
      current.userName = ""
      current.password = ""
      current.isLoggedIn = false
      current.areResourcesLoaded = false
      current.dataFeatures = []
      current.doc = {}
      current.imgCount = 0
      current.imgLoadedCount = 0
      current.imageBlobs = []
      current.accessToken = ""
      current.mapBlobs = []
      // current.mapBlobsStreetLoc = []
      // current.mapBoxMap = {}
      // current.mapBlobs = {
      //   satelliteBlobs: [],
      //   streetBlobs: []
      // }
      current.mapBlobsLoading = false
      current.mapBlobsLoaded = false
      current.map = {}
      current.constraintLayers = []
    },
    createFullMap: function(current) {
      current.mapFullView = new mapboxgl.Map({
        container: "mapBoxMapFullView",
        style: "mapbox://styles/mapbox/streets-v11", // stylesheet location
        center: [145.2617, -37.1023], // starting position [lng, lat]
        zoom: 12.3// starting zoom
      })
      current.mapFullView.on("idle", function() {
        console.log("move ended");
        current.mapFullView.getCanvas().toBlob(blob=>{
          current.mapFullViewBlob = blob
        })
      })
      current.mapFullView.on("load",()=>{
        // add constraint layer
        console.log(current.dataFeaturesFull);
        var options = {
          pointSize: 2,
          lineThickness: 4
        }

        current.addConstraintHardstands(current, current.mapFullView)
        current.addConstraintTurbines(current, current.mapFullView)
        current.addConstraintLayers(current, current.mapFullView, options)

        var objectFeatures = {
          type: "FeatureCollection",
          features: []
        }
        current.dataFeaturesFull.features.forEach(feature=>{
          let constraintItem = {
            type: "Feature",
            properties: {
              style: "circle",
              color: "#ff1010"
            },
            geometry: {
              type: "Point",
              coordinates: [feature.geometry.x, feature.geometry.y]
            }
          }
          objectFeatures.features.push(constraintItem)
        })

        current.mapFullView.addSource("FullMapPoint", {
          "type": "geojson",
          "data": objectFeatures
        });
        current.mapFullView.addLayer({
          "id": "FullMapPoint",
          "type": "circle",
          "source": "FullMapPoint",
          "paint": {
            "circle-radius": 3,
            "circle-color": "#ff1010"
          }
        })
      })
    },
    createMap: function(current) {
      current.map = new mapboxgl.Map({
        container: "mapBoxMap",
        style: "mapbox://styles/mapbox/streets-v11", // stylesheet location
        center: [current.dataFeatures[0].x, current.dataFeatures[0].y], // starting position [lng, lat]
        zoom: 13.5// starting zoom
      })
      current.map.on("idle", function() {
        console.log("move ended");
        current.map.getCanvas().toBlob(blob=>{
          current.mapBlobs[current.mapObjectId] = blob
          // var origUrl = URL.createObjectURL(blob)
          // var origImg = new Image();
          // origImg.src = origUrl;
          // origImg.addEventListener("load", function(){
          //   document.getElementById("app").appendChild(origImg)
          // })
        })
      })
      current.map.on("load",()=>{
        // add constraint layer
        current.addConstraintHardstands(current, current.map)
        current.addConstraintTurbines(current, current.map)
        current.addConstraintLayers(current, current.map)

        var mapPoint = {
          "type": "FeatureCollection",
          "features": [{
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [0, 0]
            }
          }]
        }
        current.map.addSource("Point", {
          "type": "geojson",
          "data": mapPoint
        });
        current.map.addLayer({
          "id": "point",
          "type": "circle",
          "source": "Point",
          "paint": {
            "circle-radius": 5,
            "circle-color": "#ff1010"
          }
        })
        current.dataFeatures.forEach((point,index) => {
          setTimeout(function(){
            current.mapObjectId = point.objectId
            mapPoint.features[0].geometry.coordinates = [point.x, point.y]
            current.map.getSource("Point").setData(mapPoint);
            current.map.jumpTo({center:[point.x, point.y]})
            console.log("TEST LOG ObjectId:"+point.objectId);
            if (index == current.dataFeatures.length-1) {
              current.mapBlobsLoaded = true
            }
          },2000*index)
        })
      })

    },
    getConstraintLayers: function() {
      const current = this
      var constraintIds = Array.from(Array(13).keys());
      constraintIds = constraintIds.filter(ids=> ids != 4 && ids!=10)

      constraintIds.forEach(layerId=>{
          var layerConfig = {
            url: current.constraintLayerBaseURL+layerId+"/query/",
            method: "POST",
            data: Qs.stringify({
              token: current.accessToken,
              f: "json",
              where: (layerId<2)?"objectid is not null":"FID is not null",
              outFields: "*",
              outSR: 4326
            }),
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            }
          }

          axios(layerConfig).then(result=>{
            // if layerId == 0
            var constraintLayer = "";
            if (result.data.geometryType == "esriGeometryPolyline") {
              constraintLayer = current.preparePolyLineGeoJson(result.data, layerId)
            }
            else if (result.data.geometryType == "esriGeometryPoint") {
              constraintLayer = current.preparePointGeoJson(result.data, layerId)
            }
            else if (result.data.geometryType == "esriGeometryPolygon") {
              constraintLayer = current.preparePolygonGeoJson(result.data, layerId)
            }

            current.constraintLayers[layerId] = constraintLayer
          })
      })
    },
    preparePolyLineGeoJson: function(data, index) {
      const current = this
      var constraint = {
        type: "FeatureCollection",
        features: []
      }
      data.features.forEach(feature=>{
        let constraintItem = {
          type: "Feature",
          properties: {
            style: "line",
            color: current.styles[index].color
          },
          geometry: {
            type: (feature.geometry.paths.length > 1)?"MultiLineString":"LineString",
            coordinates: (feature.geometry.paths.length > 1)?feature.geometry.paths:feature.geometry.paths[0]
          }
        }
        constraint.features.push(constraintItem)
      })
      return constraint;
    },
    preparePointGeoJson: function(data, index) {
      const current = this
      var constraint = {
        type: "FeatureCollection",
        features: []
      }
      data.features.forEach(feature=>{
        let constraintItem = {
          type: "Feature",
          properties: {
            style: "circle",
            color: current.styles[index].color
          },
          geometry: {
            type: "Point",
            coordinates: [feature.geometry.x, feature.geometry.y]
          }
        }
        constraint.features.push(constraintItem)
      })
      return constraint
    },
    preparePolygonGeoJson: function(data, index) {
      const current = this
      var constraint = {
        type: "FeatureCollection",
        features: []
      }
      data.features.forEach(feature=>{
        let constraintItem = {
          type: "Feature",
          properties: {
            style: current.styles[index].style,
            color: current.styles[index].color,
            opacity: current.styles[index].opacity
          },
          geometry: {
            type: (feature.geometry.rings.length > 1)?"MultiPolygon":"Polygon",
            coordinates: (feature.geometry.rings.length > 1)?[feature.geometry.rings]:[feature.geometry.rings[0]]
          }
        }
        constraint.features.push(constraintItem)
      })
      return constraint;
    },
    addConstraintLayers: function(current, map, styleOptions) {
      // const current = this
      if (typeof styleOptions == "undefined") {
        styleOptions = {
          pointSize: 4,
          lineThickness: 1
        }
      }
      current.constraintLayers.forEach((constraint, index)=>{
        map.addSource("constraint"+index, {
          type: "geojson",
          data: constraint
        })
        if (constraint.features[0].geometry.type.includes("Line")) {
          console.log(constraint.features[0].geometry.type);
          console.log("its a line");
          map.addLayer({
            id: "LineString"+index,
            type: constraint.features[0].properties.style,
            source: "constraint" + index,
            "layout": {
              "line-join": "round",
              "line-cap": "round"
            },
            "paint": {
              "line-color": constraint.features[0].properties.color,
              "line-width": styleOptions.lineThickness
            }
          })
        }
        else if (constraint.features[0].geometry.type.includes("Point")) {
          console.log(constraint.features[0].geometry.type);

          console.log("its a point");
          map.addLayer({
            "id": "Point"+index,
            "type": "circle",
            "source": "constraint" + index,
            "paint": {
              "circle-radius": styleOptions.pointSize,
              "circle-color": constraint.features[0].properties.color
            }
          })
        }
        else if (constraint.features[0].geometry.type.includes("Polygon")) {
          console.log(constraint.features[0].properties.opacity);
          console.log(constraint.features[0].properties);
          if (constraint.features[0].properties.style == "fill") {
            var paint = {
              "fill-color":constraint.features[0].properties.color,
              "fill-opacity":constraint.features[0].properties.opacity?constraint.features[0].properties.opacity:0.2
            }
          }
          else {
            var paint = {
              "line-color": constraint.features[0].properties.color,
            }
          }
          console.log(constraint.features[0].geometry.type);
          console.log(constraint.features[0].geometry.coordinates);
          console.log("its a polygon");
          map.addLayer({
            "id": "Polygon"+index,
            "type": constraint.features[0].properties.style,
            "source": "constraint" + index,
            "layout": {},
            "paint": paint
          })
        }
        console.log(constraint);
        // current.map.addLayer({
        //   id: "LineString"+index,
        //   type: "line",
        //   source: "constraint" + index,
        //   "layout": {
        //     "line-join": "round",
        //     "line-cap": "round"
        //   },
        //   "paint": {
        //     "line-color": constraint.features[0].properties.color,
        //     "line-width": 2
        //   }
        // })
        // }

      })
    },
    addConstraintTurbines: function(current, map){
      var dataLayerConfig = {
        url: current.constraintTurbinesBaseURL+"FeatureServer/0/query",
        method: "POST",
        data: Qs.stringify({
          token: current.accessToken,
          f: "geojson",
          where: "1=1",
          outFields: "*",
          outSR: 4326
        }),
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }
      axios(dataLayerConfig).then(result=>{
        map.addSource("Turbines", {
          "type": "geojson",
          "data": result.data
        });
        map.addLayer({
          "id": "turbines",
          "type": "symbol",
          "source": "Turbines",
          "layout": {
            "text-field": "{label}",
            "text-font": ["Arial Unicode MS Bold"],
            "text-size": 16,
            "text-offset": [0, 0.4],
            "text-anchor": "top"
          }
        })
      })
    },
    addConstraintHardstands: function(current, map){
      var dataLayerHardStandsConfig = {
        url: current.constraintHardstandsBaseURL+"FeatureServer/1/query",
        method: "POST",
        data: Qs.stringify({
          token: current.accessToken,
          f: "geojson",
          where: "1=1",
          outFields: "*",
          outSR: 4326
        }),
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }
      axios(dataLayerHardStandsConfig).then(result=>{
        map.addSource("Hardstands", {
          "type": "geojson",
          "data": result.data
        });
        map.addLayer({
          "id": "hardstands",
          "type": "line",
          "source": "Hardstands",
          "layout": {
            "line-join": "round",
            "line-cap": "round"
          },
          "paint": {
            "line-color": "#6699CC",
            "line-width": 1.5
          }
        })
      })
    },
    getBlobFromCanvas: function(type, color, index) {
      const current = this
      var canvas = document.createElement('canvas');
      var svg;
      var height=30;
      canvas.width = (1.6*height+1)+1;
      canvas.height = height + 1;
      if (type=="circle") {
        svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${height}" height="${height}">
                <circle cx="${height/2}" cy="${height/2}" r="${(height/2)-2}" fill="${color}"/>
              </svg>`;
      }
      else if (type=="line") {
       svg = `<svg xmlns="http://www.w3.org/2000/svg" height="${height}" width="${height}">
                <line x1="0" y1="${height/2}" x2="${height}" y2="${height/2}" stroke="${color}" stroke-width="2" />
              </svg>`;
      }
      else if (type=="rectFill") {
       svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${1.6*height+1}" height="${height}">
                <rect width="${1.6*height}" height="${height}" fill="${color}" fill-opacity="${([8,9].includes(index))?0.7:0.2}"/>
              </svg>`;
      }
      else if (type=="rectLine") {
       svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${1.6*height+1}" height="${height}">
                <rect width="${1.6*height}" height="${height}" stroke="${color}" stroke-width="2" fill="#FFF"/>
              </svg>`;
      }
      var ctx = canvas.getContext("2d");
      const blob = new Blob([svg], {type: 'image/svg+xml'});
      const url = URL.createObjectURL(blob);
      var img = new Image();
      img.src = url;
      img.addEventListener('load', function () {
        console.log("image onload");
        ctx.drawImage(this, 0, 0);
        URL.revokeObjectURL(url);
        canvas.toBlob(function(blob){
          current.legendBlobs[index] = blob
          // document.getElementById("app").appendChild(img)
        })
      });
    },
    setRotateImage: function(current, imageBlob, imageId) {
      var optionsResized = {
        orientation: 6,
        canvas: true,
        maxWidth: 180,
        maxHeight: 240
      }
      console.log(imageBlob);
      loadImage(imageBlob, function(canvas) {
        canvas.toBlob(function(rotateBlob) {
          console.log(rotateBlob);
          current.imageBlobs[imageId] = rotateBlob
        })
      }, optionsResized)

      var options = {
        orientation: 6,
        canvas: true
      }
      loadImage(imageBlob, function(canvas) {
        canvas.toBlob(function(rotateBlob) {
          console.log(rotateBlob);
          current.imageBlobsOriginal[imageId] = rotateBlob
        })
      }, options)
    },
    createObjectBlobFromCanvas: function() {
      const current = this
      var canvas = document.createElement('canvas');
      var height=30;
      canvas.width = (1.6*height+1)+1;
      canvas.height = height + 1;
      var svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${height}" height="${height}">
              <circle cx="${height/2}" cy="${height/2}" r="${(height/2)-2}" fill="#ff1010"/>
            </svg>`;
      var ctx = canvas.getContext("2d");
      const blob = new Blob([svg], {type: 'image/svg+xml'});
      const url = URL.createObjectURL(blob);
      var img = new Image();
      img.src = url;
      img.addEventListener('load', function () {
        ctx.drawImage(this, 0, 0);
        URL.revokeObjectURL(url);
        canvas.toBlob(function(blob){
          current.objLegendBlob = blob
        })
      });
    }
  },
  mounted() {
    const current = this
    mapboxgl.accessToken = current.mapToken
    current.styles.forEach((style, index) => {
      var type = ""
      if (index < 2) {
        type = "line"
      }
      else if (typeof style.style != "undefined" && style.style=="fill") {
        type = "rectFill"
      }
      else if (typeof style.style != "undefined" && style.style=="line") {
        type = "rectLine"
      }
      else {
        type = "circle"
      }
      current.getBlobFromCanvas(type, style.color, index)
    })
    current.createObjectBlobFromCanvas();
    console.log(current.legendBlobs);
  },
  updated() {
    const current = this
    console.log("updated");
    if (current.dataFeatures.length > 0 && !current.mapBlobsLoading) {
      current.mapBlobsLoading = true
      current.createFullMap(current)
      current.createMap(current)
    }
  },
  watch: {
    imgLoadedCount: function() {
      const current = this
      if (current.imgLoadedCount == current.imgCount && current.imgCount != 0) {
          current.areResourcesLoaded = true
      }
      else {
        current.areResourcesLoaded = false
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.mapStyle {
  position: static;
  height: 400px!important;
  visibility: hidden;
}
.mapStyle2 {
  position: static;
  height: 800px!important;
  visibility: hidden;
}
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */

/* .dijitDialogTitleBar {
    border: 1px solid #ffffff;
    border-top: none;
    background-color: #abd6ff;
    background-repeat: repeat-x;
    background-image: -moz-linear-gradient(rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
    background-image: -webkit-linear-gradient(rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
    background-image: -o-linear-gradient(rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
    background-image: linear-gradient(rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
    _background-image: none;
    padding: 5px 7px 4px 7px;
} */
</style>
